import {
    OfferDtoCompatible,
    Calculation,
    PaymentStructure,
    PaymentFrequency,
} from '@servicetitan/financing-api-client';

/**
 * Adapter function to convert an Offer to a Calculation
 * Used when offers need to be displayed in components that expect Calculation types
 */
export function offerToCalculationAdapter(offer: OfferDtoCompatible): Calculation {
    // Extract promotional terms if payment structure is DeferredInterestAndPrincipal
    let promotionalTerms = 0;
    if (offer.paymentStructure === PaymentStructure.DeferredInterestAndPrincipal) {
        try {
            const promotionDetails = (offer as any)?.promotion?.details;
            if (promotionDetails && typeof promotionDetails === 'string') {
                // Extract number from strings like "12 months"
                const monthMatch = promotionDetails.match(/(\d+)/);
                if (monthMatch) {
                    promotionalTerms = parseInt(monthMatch[1], 10);
                }
            }
        } catch {
            // If extraction fails, keep promotionalTerms as 0
            promotionalTerms = 0;
        }
    }

    return {
        // Required boolean properties
        hasPromo: false,
        eligibleForApplication: true,

        // Required numeric properties - map from offer
        loanAmount: offer.approvedAmount ?? 0,
        defaultRate: offer.interestRate ?? 0,
        defaultMonthlyPayment: offer.monthlyPayment ?? 0,
        defaultTerms: offer.term ?? 0,

        // Required numeric properties - set reasonable defaults
        promotionalRate: 0,
        promotionalMonthlyPayment: 0,
        promotionalTerms,
        minLoanAmount: 0,
        maxLoanAmount: offer.approvedAmount ?? 0,

        // Required enum
        paymentStructure: offer.paymentStructure ?? PaymentStructure.NotSet,

        // Optional properties with reasonable defaults
        planNumber: offer.id,
        planType: 'Standard Installment',
        amortization: (offer as any).amortization ?? offer.term ?? 0,
        paymentFrequency: (offer as any).paymentFrequency ?? PaymentFrequency.Monthly,
        description: `${offer.term} month term at ${offer.interestRate}% APR`,
        displayDescription: `${offer.term} month term at ${offer.interestRate}% APR`,
        totalAmount: (offer.monthlyPayment ?? 0) * (offer.term ?? 0),
        disclaimerText: null,
        disclosureText: null,
        promotionalTotalAmount: null,
        hasLowestPayment: offer.hasLowestPayment,
        hasLowestRate: offer.hasLowestRate,
        suggestedMonthlyPayment: null,
        suggestedTerms: null,
    };
}
